<div fxLayout="column" fxFlexFill class="content-container" fxLayoutGap="5px">
  <app-grid-filter placeholder="Type '/' to bring up a list of available filters, or type any text to search"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
    <app-filter-row-additional-content>
      <button mat-raised-button color="primary" matTooltip="Add new ip address to white list" *ngIf="hasEditAccess"
              (click)="navigateToDetails()">
        + Add
      </button>
    </app-filter-row-additional-content>
  </app-grid-filter>

  <div fxFlex class="stretched-container">
    <app-firewall-grid #firewallGrid [filterChangeEvent]="filterChangeEvent"></app-firewall-grid>
  </div>
</div>
